<template>
    <button @click="showMessage" class="btn" type="button" v-bind:class="classes" v-bind:id="id"
            v-bind:name="name">
        {{ label }}
    </button>
</template>

<script>
    export default {
        name: "buttonConfirmComponent",
        props: {
            label: String,
            name: String,
            id: String,
            classes: String,
            title: String,
            message: String,
            footer: String,
            funcOk: Function,
            funcCancel: Function,
        },
        methods: {
            showMessage() {
                appUtil.showConfirmationDialog(
                    this.title,
                    this.message,
                    this.footer
                )
                    .then((result) => {
                        if (result.value) {
                            this.$emit('ok');
                            if (this.funcOk) {
                                this.funcOk();
                            }
                        } else {
                            this.$emit('cancel');
                            if (this.funcCancel) {
                                this.funcCancel();
                            }
                        }
                    });
            }
        },
    }
</script>

<style scoped>

</style>